<script setup>
import { storeToRefs } from 'pinia';
import { useScreensizeStore } from '@stores/useScreensizeStore';
import { trans } from '../../../_00_elements/translation';
import { useAccountStore } from '../store/account';
import CreateInvoiceAction from './actions/CreateInvoiceAction.vue';
import { STRIPE_LIMITED } from '../constants/constants';
import StripeSoonLimited from '../Onboarding/StripeSoonLimited';
import InvoiceTable from './InvoiceDataTable.vue';
import InvoiceDataList from './InvoiceDataList.vue';
import InvoiceFilters from './InvoiceFilters.vue';

const { isMobile } = storeToRefs(useScreensizeStore());
const accountStore = useAccountStore();

accountStore.setStripeAccountStatus(window.initialState.stripeAccountStatus);
</script>

<template>
  <div class="invoices">
    <div class="invoices__content">
      <div class="invoices__header">
        <div class="invoices__header-title">
          {{ trans('gestion.invoices.title') }}
        </div>
        <div class="invoices__header-buttons">
          <CreateInvoiceAction ref="createInvoiceAction" :stripe-account-status="accountStore.stripeAccountStatus" />
        </div>
      </div>
      <StripeSoonLimited v-if="STRIPE_LIMITED.includes(accountStore.stripeAccountStatus)" />

      <InvoiceFilters />
      <InvoiceDataList v-if="isMobile" />
      <InvoiceTable v-else :hidden-columns="[ 'seller' ]" />
    </div>
  </div>
</template>
